import AbstractReactiveListEntity from "~/core-ui/ts/request/AbstractReactiveListEntity";
import ReactiveFilterableListRequest from "~/core-ui/ts/request/ReactiveFilterableListRequest";

export default class ReactiveFilterableListOpenApiRequest<T extends object, T2 extends object> extends ReactiveFilterableListRequest<T, T2> {
    protected processData(data: AbstractReactiveListEntity<T>) {
        data.page = this.requestConfig.p.page;
        data.onPage = (data as any).limit;
        data.onPageDisabled = false;
        super.processData(data);
    }
}